export function polishCurrencyTransformer(value) {
  if (value === null || value === void 0 || value === "") {
    return "";
  }
  let numericValue;
  if (typeof value === "string") {
    const extractedPrice = extractPriceFromText(value);
    if (extractedPrice === null || extractedPrice === void 0) {
      return "";
    }
    numericValue = extractedPrice;
  } else {
    numericValue = value;
  }
  if (Number.isNaN(numericValue)) {
    return "";
  }
  const hasDecimals = numericValue % 1 !== 0;
  let formattedNumber = hasDecimals ? numericValue.toFixed(2).replace(".", ",") : Math.floor(numericValue).toString();
  formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, "\xA0");
  return `${formattedNumber} z\u0142`;
}
export function extractPriceFromText(text) {
  if (!text) return null;
  const priceRegex = /(\d+(?:[ .,]\d+)*)\s*zł/;
  const match = text.match(priceRegex);
  if (!match) return void 0;
  const price = match[1].replace(/\s/g, "").replace(/\.(?=.*\d)/g, "").replace(",", ".");
  return Number.parseFloat(price);
}
